export default {
  setIcons: (state, icons) => {
    state.icons = icons;
  }
};
